import React, { Component } from "react";
import styled from "styled-components";
import _ from "lodash";

import { LibraryView } from "common/constants";
import { ActionPermissionsObject, WorkspaceResourceType } from "common/interfaces";
import WorkspaceController from "js/controllers/WorkspaceController";
import AppController from "js/core/AppController";
import { OnMountedReporter } from "js/core/utilities/useMountedAt";
import { LibraryPaneLayout } from "js/editor/PresentationLibrary/LibraryPaneLayout";
import { FlexBox } from "js/react/components/LayoutGrid";

import { disposeAllIndexes } from "js/react/views/AddSlide/DataServices";

import PlayerSettingsPane from "./panes/PlayerSettingsPane";
import PresentationTemplatesPane from "../SharedResources/PresentationTemplatesPane";
import TeamBrandingGuardrailsPane from "./panes/TeamBrandingGuardrailsPane";
import TeamFoldersPane from "./panes/TeamFoldersPane";
import TeamSharedThemesPane from "./panes/TeamSharedThemesPane";
import SharedSlidesPane, { ALL_SLIDES_RESOURCE_TYPES, SHARED_SLIDES_RESOURCE_TYPES, SLIDE_TEMPLATES_RESOURCE_TYPES } from "../SharedResources/SharedSlidesPane";
import SharedAssetsPane from "../SharedResources/SharedAssetsPane";
import { TeamResourceTypes } from "./TeamResourceTypes";

export { TeamResourceTypes } from "./TeamResourceTypes";

const Styler = styled.div`
    width: 100%;
    height: 100%;
    display: flex;

    .search-container {
        padding-top: 5px;
    }
`;

class TeamResources extends Component {
    state = {
        selectedPane: TeamResourceTypes.PRESENTATION_TEMPLATES,
    }

    constructor(props) {
        super(props);

        if (props.pane) {
            this.state.selectedPane = props.pane;
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.pane != prevProps.pane) {
            this.setState({ selectedPane: this.props.pane });
        }
    }

    componentWillUnmount() {
        disposeAllIndexes();
    }

    handleSelectResourcePane = (pane, folderId = null) => {
        if (Array.isArray(pane)) {
            if (_.isEqual(pane, SHARED_SLIDES_RESOURCE_TYPES)) {
                pane = TeamResourceTypes.SHARED_SLIDES;
            } else if (_.isEqual(pane, SLIDE_TEMPLATES_RESOURCE_TYPES)) {
                pane = TeamResourceTypes.SLIDE_TEMPLATES;
            } else if (_.isEqual(pane, ALL_SLIDES_RESOURCE_TYPES)) {
                pane = TeamResourceTypes.SLIDES;
            }
        }

        AppController.showTeamResources({ pane, folderId });
    }

    handleSelectPresentationTemplate = (presentationId, isDoubleClick, selectedFolderId) => {
        if (!presentationId) {
            return;
        }

        const canManageSharedResources = WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage;
        if (isDoubleClick && canManageSharedResources) {
            AppController.showEditor({ presentationId, folderId: selectedFolderId });
        }
    }

    getWorkspaceResourceTypes = type => {
        if (type === TeamResourceTypes.SLIDE_TEMPLATES) {
            return [WorkspaceResourceType.SLIDE_TEMPLATE];
        }

        if (type === TeamResourceTypes.SHARED_SLIDES) {
            return [WorkspaceResourceType.SLIDE];
        }

        return [WorkspaceResourceType.SLIDE, WorkspaceResourceType.SLIDE_TEMPLATE];
    }

    render() {
        const {
            folderId,
            onReady = () => { },
            onResizeSidebar,
            showNavigationSidebar = true,
            sideBarWidth
        } = this.props;
        const { selectedPane } = this.state;
        const isSlidesPane = selectedPane === TeamResourceTypes.SLIDE_TEMPLATES ||
            selectedPane === TeamResourceTypes.SHARED_SLIDES ||
            selectedPane === TeamResourceTypes.SLIDES;
        const isAssetsPane = selectedPane === TeamResourceTypes.TEAM_ASSETS ||
            selectedPane === TeamResourceTypes.TEAM_ASSETS_IMAGES ||
            selectedPane === TeamResourceTypes.SHARED_ASSETS_LOGOS;

        return (
            <LibraryPaneLayout
                libraryView={LibraryView.TEAM_RESOURCES}
                onResizeSidebar={onResizeSidebar}
                showNavigationSidebar={showNavigationSidebar}
                sideBarWidth={sideBarWidth}
                teamPane={selectedPane}
            >
                <FlexBox fill vertical top>
                    <Styler>
                        <OnMountedReporter onMounted={onReady} />
                        {selectedPane === TeamResourceTypes.PRESENTATION_TEMPLATES &&
                            <PresentationTemplatesPane
                                editable={true}
                                onReady={onReady}
                                onSelect={this.handleSelectPresentationTemplate}
                                folderId={folderId}
                                onSelectFolder={this.handleSelectResourcePane}
                            />
                        }
                        {isSlidesPane &&
                            <SharedSlidesPane
                                isManageLibrary
                                resourceTypes={this.getWorkspaceResourceTypes(selectedPane)}
                                folderId={folderId}
                                onSelectFolder={this.handleSelectResourcePane}
                            />
                        }
                        {selectedPane === TeamResourceTypes.TEAM_THEMES &&
                            <TeamSharedThemesPane />
                        }
                        {selectedPane === TeamResourceTypes.TEAM_FOLDERS &&
                            <TeamFoldersPane />
                        }
                        {selectedPane === TeamResourceTypes.TEAM_BRANDING_GUARDRAILS &&
                            <TeamBrandingGuardrailsPane />
                        }
                        {isAssetsPane &&
                            <SharedAssetsPane
                                resourceType={selectedPane}
                                editable
                                folderId={folderId}
                                onSelectFolder={this.handleSelectResourcePane}
                            />
                        }
                        {selectedPane === TeamResourceTypes.PLAYER_SETTINGS &&
                            <PlayerSettingsPane />
                        }
                    </Styler>
                </FlexBox>
            </LibraryPaneLayout>
        );
    }
}

export default TeamResources;
